function view (path) {
  return () => import(/* webpackChunkName: 'admin-v1' */ '@/views/admin/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RAdmin = [
  {
    path: '/admin/dashboard',
    component: view('Dashboard'),
    name: 'admin.dashboard',
    authorizedRole: 'admin'
  }
]

const RAdminAccounts = [
  {
    path: '/admin/accounts/users',
    component: view('accounts/Users'),
    name: 'admin.accounts.users',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/accounts/suppliers',
    component: view('accounts/Suppliers'),
    name: 'admin.accounts.suppliers',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Suppliers',
          active: true
        }
      ]
    }
  }
]

const RAdminMaintenances = [
  {
    path: '/admin/maintenances/warehouses',
    component: view('maintenances/Warehouses'),
    name: 'admin.maintenances.warehouses',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Warehouses',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/locations',
    component: view('maintenances/Locations'),
    name: 'admin.maintenances.locations',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Locations',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/groups',
    component: view('maintenances/Groups'),
    name: 'admin.maintenances.groups',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Groups',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/categories',
    component: view('maintenances/Categories'),
    name: 'admin.maintenances.categories',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Categories',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/products',
    component: view('maintenances/Products'),
    name: 'admin.maintenances.products',
    authorizedRole: 'admin',
    meta: {
      breadcrumb: [
        {
          text: 'Admin'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Products',
          active: true
        }
      ]
    }
  }
]

export default RAdmin.concat(
  RAdminAccounts,
  RAdminMaintenances
)
